<template>
    <div class="p-3">
        <h3>RL 3.19 Rekapitulasi Cara Bayar</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Rekapitulasi Cara Bayar" :filter-configs="filterConfigs"
            :table-options="tableOptions" :show-filter="true" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'year',
                    label: 'Tahun',
                    field: 'year',
                    type: 'year',
                    colClass: 'col-sm-3',
                    component: 'DropDownYear'
                }
            ],
            tableOptions: {
                baseUrl: '/api/rekapitulasi-pelayanan/kegiatan-pelayanan-cara-bayar',
                layout: 'fitDataStretch',
                responsiveLayout: 'collapse',
                columns: [
                    {
                        title: "No.",
                        field: "no",
                        hozAlign: "center",

                    },
                    {
                        title: "Cara Pembayaran",
                        field: "cara_bayar",
                    },
                    {
                        title: "Pasien Rawat Inap",
                        columns: [
                            {
                                title: "Jumlah Pasien Keluar",
                                field: "px_ranap_jml_px_keluar",
                                hozAlign: "center",
                            },
                            {
                                title: "Jumlah Lama Dirawat",
                                field: "px_ranap_jml_lama_dirawat",
                                hozAlign: "center",
                            },
                        ]
                    },
                    {
                        title: "Jumlah Pasien Rawat Jalan",
                        field: "jml_px_rajal",
                        hozAlign: "center",
                    },
                    {
                        title: "Jumlah Pasien Rawat Jalan",
                        columns: [
                            {
                                title: "Laboratorium",
                                field: "jml_px_rajal_lab",
                                hozAlign: "center",
                            },
                            {
                                title: "Radiologi",
                                field: "jml_px_rajal_rad",
                                hozAlign: "center",
                            },
                            {
                                title: "Lain - lain",
                                field: "jml_px_rajal_lain",
                                hozAlign: "center",
                            },
                        ]
                    },

                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
